import {
    ACTIVE_SEASONAL_EVENTBRITE_CATEGORY,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
} from '@eventbrite/categories';
import { track } from '@eventbrite/datalayer-library';
import { Tabs, TabsItem } from '@eventbrite/marmalade';
import { Location } from 'history';
import React from 'react';
import { Sticky } from 'react-sticky';
import { DateType } from '../../../../constants/dates';
import {
    BUCKET_KEY_TO_URL_PARAM,
    DEFAULT_TAB_FOR_SEASONAL,
    SeasonalTabs,
    SeasonalTabsSearchQuery,
} from '../../constants/seasonal';
import { useRouteContext, useSearchContext } from '../../context';
import './SeasonalBucketsContainer.scss';

const useSeasonalBucketTracking = () => {
    const trackSeasonalPageBucket = (
        location: Location<string> | undefined,
        bucketKey: string,
    ) => {
        track({
            eventName: 'SeasonalPageBucket',
            eventData: {
                searchLocation: location,
                bucket: bucketKey,
            },
        });
    };

    return trackSeasonalPageBucket;
};

const useBucketQueryUpdater = () => {
    const { setQuery } = useSearchContext();

    const updateSearchQuery = (bucketKey: string, parsedDate: DateType[]) => {
        const query = SeasonalTabsSearchQuery[bucketKey];

        query['dates'] = parsedDate;

        if (query && setQuery) {
            setQuery(query);
        }
    };

    return updateSearchQuery;
};

export const SeasonalBucketsContainer = () => {
    const { location, parsedValues, history } = useRouteContext();
    const defaultTab = parsedValues?.bucket || DEFAULT_TAB_FOR_SEASONAL['SPD'];

    const trackSeasonalPageBucket = useSeasonalBucketTracking();
    const updateSearchQuery = useBucketQueryUpdater();

    const handleBucketClick = (bucketKey: string, bucketUrlParam: string) => {
        const parsedDate = parsedValues?.date
            ? [parsedValues?.date]
            : ['current_future'];
        if (parsedValues) {
            parsedValues.bucket = bucketKey;
        }
        const params = new URLSearchParams(location?.search);
        params.set('bucket', bucketUrlParam || bucketKey);
        updateRoute(params);
        trackSeasonalPageBucket(location, parsedValues?.bucket || bucketKey);
        updateSearchQuery(
            parsedValues?.bucket || bucketKey,
            parsedDate as DateType[],
        );
    };

    const updateRoute = (params: URLSearchParams) => {
        const pathname =
            location?.pathname ||
            `/b/online/${EVENTBRITE_CATEGORY_TO_REFINEMENT[ACTIVE_SEASONAL_EVENTBRITE_CATEGORY]}/`;
        const path = `${pathname}?${params.toString()}`;
        history?.push(path);
    };

    return (
        <Sticky>
            {({ style, isSticky }) => (
                <div style={{ ...style, zIndex: 1000 }}>
                    <div
                        className={`seasonal-buckets-container ${
                            isSticky && 'sticky-container'
                        }`}
                    >
                        <div className={`seasonal-buckets-container-bucket`}>
                            <Tabs
                                defaultValue={defaultTab}
                                aria-label="seasonal-buckets-tab"
                                onValueChange={(value) =>
                                    handleBucketClick(
                                        value,
                                        BUCKET_KEY_TO_URL_PARAM[value],
                                    )
                                }
                            >
                                {SeasonalTabs['SPD'].map((tab, index) => (
                                    <TabsItem
                                        key={index}
                                        value={tab.key.toString()}
                                    >
                                        {tab.name.toString()}
                                    </TabsItem>
                                ))}
                            </Tabs>
                        </div>
                    </div>
                </div>
            )}
        </Sticky>
    );
};
